import React from "react";
import styles from "./style.module.css";

const LoadingIndicator = (props) => (
  <div className={styles.loadingIndicator} style={props.style ? props.style : {}}>
    <div style={{ background: props.color || "var(--aible-color)" }} />
    <div style={{ background: props.color || "var(--aible-color)" }} />
    <div style={{ background: props.color || "var(--aible-color)" }} />
    <div style={{ background: props.color || "var(--aible-color)" }} />
    <div style={{ background: props.color || "var(--aible-color)" }} />
    <div style={{ background: props.color || "var(--aible-color)" }} />
    <div style={{ background: props.color || "var(--aible-color)" }} />
    <div style={{ background: props.color || "var(--aible-color)" }} />
  </div>
);

const LoadingIndicatorBad = (props) => (
  <div className={styles.ldsRing}>
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default LoadingIndicator;
